export default __webpack_public_path__ + "static/media/cvm.6f51fe22.png";